import GeneralReportModel, {
  ACTION_TYPES as CRUD_ACTION_TYPES,
} from "../general-report";

export const ACTION_TYPES = { ...CRUD_ACTION_TYPES };

export const RealEstateReportStoreModel = {
  ...GeneralReportModel("realestatereports"),
};
